// extracted by mini-css-extract-plugin
export default {"wrapper":"Menu_wrapper__64V13","menuItem":"Menu_menuItem__vU-BK","selected":"Menu_selected__mk3jK"};